import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Project Members
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type ProjectmembersParameters = ProjectmembersMemberAddedParameters | ProjectmembersLimitPaywallOpenedParameters | ProjectmembersLimitPaywallSelectedParameters;
export type ProjectmembersEvents = ProjectmembersMemberAddedEvent | ProjectmembersLimitPaywallOpenedEvent | ProjectmembersLimitPaywallSelectedEvent;

export interface ProjectmembersMemberAddedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	type: string; // type of the added member, possible values are "internal", "external"
}

export type ProjectmembersMemberAddedParametersSpecific = Omit<
	ProjectmembersMemberAddedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectmembersMemberAddedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectmembersMemberAddedEventBuilder {
	constructor(private specificParameters: ProjectmembersMemberAddedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectmembersMemberAddedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectmembersMemberAddedParametersSpecific,
            ProjectmembersMemberAddedParameters,
			(params: ProjectmembersMemberAddedParameters) => ProjectmembersMemberAddedEvent
		>(this.specificParameters, projectmembersMemberAddedParametersGlobal, globalParams, (params) => new ProjectmembersMemberAddedEvent(params));
	}
}

/**
 * A member was added to a project. This includes internal and external members which can be distinguished by the type parameter.
 */
export class ProjectmembersMemberAddedEvent extends CraftnoteEvent<ProjectmembersMemberAddedParameters>{
  constructor(parameters: ProjectmembersMemberAddedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "member_internal_added"
		},
		{
			name: "iterable",
			eventName: "projectmembers_member_added"
		},
	]);
  }
}
export interface ProjectmembersLimitPaywallOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	context: string; // context of the restriction, either "project-creation", "project-members", "planning-board", or "project-restore"
	role: string; // the role of user, must be any of "owner", "supervisor"
}

export type ProjectmembersLimitPaywallOpenedParametersSpecific = Omit<
	ProjectmembersLimitPaywallOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectmembersLimitPaywallOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectmembersLimitPaywallOpenedEventBuilder {
	constructor(private specificParameters: ProjectmembersLimitPaywallOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectmembersLimitPaywallOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectmembersLimitPaywallOpenedParametersSpecific,
            ProjectmembersLimitPaywallOpenedParameters,
			(params: ProjectmembersLimitPaywallOpenedParameters) => ProjectmembersLimitPaywallOpenedEvent
		>(this.specificParameters, projectmembersLimitPaywallOpenedParametersGlobal, globalParams, (params) => new ProjectmembersLimitPaywallOpenedEvent(params));
	}
}

/**
 * A paywall was shown to the user when trying to create a new project or inviting members into an existing project.
 */
export class ProjectmembersLimitPaywallOpenedEvent extends CraftnoteEvent<ProjectmembersLimitPaywallOpenedParameters>{
  constructor(parameters: ProjectmembersLimitPaywallOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projectmembers_limit_paywall_opened"
		},
		{
			name: "iterable",
			eventName: "projectmembers_limit_paywall_opened"
		},
	]);
  }
}
export interface ProjectmembersLimitPaywallSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	context: string; // context of the restriction, either "project-creation", "project-members", "planning-board", or "project-restore"
	role: string; // the role of user, must be any of "owner", "supervisor"
}

export type ProjectmembersLimitPaywallSelectedParametersSpecific = Omit<
	ProjectmembersLimitPaywallSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const projectmembersLimitPaywallSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class ProjectmembersLimitPaywallSelectedEventBuilder {
	constructor(private specificParameters: ProjectmembersLimitPaywallSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<ProjectmembersLimitPaywallSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			ProjectmembersLimitPaywallSelectedParametersSpecific,
            ProjectmembersLimitPaywallSelectedParameters,
			(params: ProjectmembersLimitPaywallSelectedParameters) => ProjectmembersLimitPaywallSelectedEvent
		>(this.specificParameters, projectmembersLimitPaywallSelectedParametersGlobal, globalParams, (params) => new ProjectmembersLimitPaywallSelectedEvent(params));
	}
}

/**
 * A user clicked on the CTA of the project member restriction paywall.
 */
export class ProjectmembersLimitPaywallSelectedEvent extends CraftnoteEvent<ProjectmembersLimitPaywallSelectedParameters>{
  constructor(parameters: ProjectmembersLimitPaywallSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "projectmembers_limit_paywall_selected"
		},
	]);
  }
}
